/* Every API path the web core calls, in one place. */
const e = encodeURIComponent;

export const API = {
  session: '/api/v1/auth/me',
  signOut: '/api/v1/auth/logout',
  /** Google sign-in starts here (a browser navigation; the API redirects to Google and back). */
  googleSignIn: '/api/v1/auth/google/start',
  /** Google sign-in with a return path inside the app (`?redirect=`). */
  googleStart: (redirect?: string) => `/api/v1/auth/google/start${redirect ? `?redirect=${e(redirect)}` : ''}`,
  jobs: '/api/v1/jobs',
  job: (id: string) => `/api/v1/jobs/${e(id)}`,
  jobEvents: (id: string) => `/api/v1/jobs/${e(id)}/events`,
  jobCancel: (id: string) => `/api/v1/jobs/${e(id)}/cancel`,
  /** The API's approve route: `{approvalId, decision: allow | allow_task | deny, editedPreview?}`. */
  jobApprove: (id: string) => `/api/v1/jobs/${e(id)}/approve`,
  /** Alias with the client's words: `{decision: approved | denied | edited | handoff, allowForTask?, editedPreview?}`. */
  jobApproval: (id: string, approvalId: string) => `/api/v1/jobs/${e(id)}/approvals/${e(approvalId)}`,
  billingSummary: '/api/v1/billing/summary',
  notifications: '/api/v1/notifications',
  notificationRead: (id: string) => `/api/v1/notifications/${e(id)}/read`,
  notificationsReadAll: '/api/v1/notifications/read-all',
  agentApprovals: '/api/v1/agent/approvals',
  agentKill: '/api/v1/agent/kill',
  /** OS share sheet target (devapi module). Browsers POST multipart here and get a 303 to /chat/new?share=<id>. */
  shareTarget: '/api/v1/share-target',
  shareTargetItem: (id: string) => `/api/v1/share-target/${e(id)}`,
  shared: (token: string) => `/api/v1/shared/${e(token)}`,
  sharedFork: (token: string) => `/api/v1/shared/${e(token)}/fork`,
  replay: (token: string) => `/api/v1/replay/${e(token)}`,
  replayFork: (token: string) => `/api/v1/replay/${e(token)}/fork`,
  publicForm: (slug: string) => `/api/v1/sheets/f/${e(slug)}`,
} as const;
